import { defineComponent as _defineComponent } from 'vue'
import ModalItem from '@/component/ModalItem/ModalItem.vue';
import { ref, watch } from 'vue';
import lodash from 'lodash';
import { putDeliverInof } from '@/api/order/order-list';
import { message } from 'ant-design-vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderEditOperation',
  props: {
    record: null
  },
  setup(__props: any) {

const props = __props as {
  record: any;
};


const loading = ref(false);
const info = ref(lodash.cloneDeep(props.record));
const editIds = ref<number[]>([]);
function edit(id) {
  editIds.value.push(id);
}
function cancel(id) {
  editIds.value = editIds.value.filter(i => i != id);
  info.value = lodash.cloneDeep(props.record);
}
async function save(id, company, number) {
  loading.value = true;
  const res = await putDeliverInof(id, company, number);
  loading.value = false;
  if (res) {
    props.record.express = info.value?.express;
  }
  cancel(id);
}

function copy(text) {
  navigator.clipboard
    .writeText(text)
    .then(() => {
      message.success('复制成功');
    })
    .catch(() => {
      //复制兼容性处理
      const el = document.createElement('input');
      el.setAttribute('value', text);
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      message.success('复制成功');
    });
}

return { __sfc: true,props, loading, info, editIds, edit, cancel, save, copy, ModalItem }
}

})